import { CancelOutlined, CheckCircleOutlined } from '@mui/icons-material';
import { Box, PopoverOrigin } from '@mui/material';
import { useUuid } from '@procureai/ui-mui';
import { bindHover, bindMenu, usePopupState } from 'material-ui-popup-state/hooks';
import HoverMenu from 'material-ui-popup-state/HoverMenu';
import { Union } from 'ts-toolbelt';

import {
  NegotiationCaseIsReleasableCellMenu,
  NegotiationCaseIsReleasableCellMenuProps,
} from '~/components/NegotiationCaseIsReleasableCellMenu/NegotiationCaseIsReleasableCellMenu';

const ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'center',
};
const TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'center',
};

export interface NegotiationCaseIsReleasableButtonProps extends NegotiationCaseIsReleasableCellMenuProps {
  isReleasable: Union.Nullable<boolean>;
}

export const NegotiationCaseIsReleasableButton = ({
  isReleasable,
  ...menuProps
}: NegotiationCaseIsReleasableButtonProps) => {
  const popupId = useUuid();
  const popupState = usePopupState({ variant: 'popover', popupId });

  return (
    <>
      <Box {...bindHover(popupState)} sx={{ display: 'flex', alignItems: 'center' }}>
        {isReleasable ? <CheckCircleOutlined color="success" /> : <CancelOutlined color="error" />}
      </Box>
      <HoverMenu {...bindMenu(popupState)} anchorOrigin={ANCHOR_ORIGIN} transformOrigin={TRANSFORM_ORIGIN}>
        {popupState.isOpen && <NegotiationCaseIsReleasableCellMenu {...menuProps} />}
      </HoverMenu>
    </>
  );
};
